import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

export type Language = {
  en: boolean;
  de: boolean;
  fr: boolean;
  nl: boolean;
};

@Component({
  standalone: true,
  selector: 'email-referrals-logo',
  styleUrls: ['./email-referrals-logo.component.less'],
  template: `
    <img
      *mailgunIf="lang.en"
      class="logo-referrals"
      [src]="'assets/referrals.png'"
      [width]="243"
      [height]="41"
      alt="ReferralsHub"
    />
    <img
      *mailgunIf="lang.de"
      class="logo-referrals logo-referrals-de"
      [src]="'assets/referralshub-DE.png'"
      [width]="343"
      [height]="41"
      alt=""
    />
    <img
      *mailgunIf="lang.fr"
      class="logo-referrals logo-referrals-fr"
      [src]="'assets/referralshub-FR.png'"
      [width]="337"
      [height]="41"
      alt=""
    />
    <img
      *mailgunIf="lang.nl"
      class="logo-referrals"
      [src]="'assets/referrals.png'"
      [width]="243"
      [height]="41"
      alt="ReferralsHub"
    />
  `,
  imports: [EmailMailgunIfDirective],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class EmailReferralsLogoComponent {
  @Input({ required: true }) public lang: WrappedValue<Language>;
}
